export default __webpack_public_path__ + "static/media/loader.13853df3.svg";